import { createAsyncThunk } from "@reduxjs/toolkit";
import ReferralServices from "../../Services/ReferralServices";

export const sendReferralOtp = createAsyncThunk(
  "referral/sendOtp",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ReferralServices.sendOtp();
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const resendReferralOtp = createAsyncThunk(
  "referral/referralResendOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReferralServices.referralresendOtp(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const verifyReferralOtp = createAsyncThunk(
  "referral/validate-otp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReferralServices.verifyOtp(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const fetchReferralStats = createAsyncThunk(
  "referral/fetchStats",
  async (_, { rejectWithValue }) => {
    try {
      const [summaryRes, childrenRes] = await Promise.all([
        ReferralServices.getAccountSummary(),
        ReferralServices.getReferralChildren(),
      ]);
      return {
        totalReferralEarnings: summaryRes.data?.totalReferralEarnings ?? 0,
        referralHistory: childrenRes.data?.content ?? [],
        totalReferralCount: childrenRes.data?.total_records ?? 0,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const referralLink = createAsyncThunk(
  "referral/link",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReferralServices.referralLink(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);
